import PropTypes from "prop-types";

import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

import ApiKeyForm from "./ApiKeyForm";

const ApiKeyModal = ({ open, onOpenChange, onCreated }) => (
  <Dialog open={open} onOpenChange={onOpenChange} disablePointerDismissal>
    <DialogContent className="tw:sm:max-w-lg">
      <DialogTitle>New API Key</DialogTitle>
      <ApiKeyForm onSuccess={onCreated} onCancel={() => onOpenChange(false)} />
    </DialogContent>
  </Dialog>
);

ApiKeyModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  onCreated: PropTypes.func.isRequired,
};

export default ApiKeyModal;
